var React = require('react');

function Autorenew (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24 12v6l8-8-8-8v6C15.16 8 8 15.16 8 24c0 3.14.92 6.05 2.48 8.52l2.92-2.92c-.89-1.67-1.4-3.57-1.4-5.6 0-6.63 5.37-12 12-12zm13.52 3.48L34.6 18.4c.89 1.67 1.4 3.57 1.4 5.6 0 6.63-5.37 12-12 12v-6l-8 8 8 8v-6c8.84 0 16-7.16 16-16 0-3.14-.92-6.05-2.48-8.52z"}));
}

Autorenew.displayName = "Autorenew";

Autorenew.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48"};

module.exports = Autorenew;

Autorenew.default = Autorenew;



// WEBPACK FOOTER //
// ./node_modules/pui-css-iconography/svgs/autorenew.svg